export function startVersionChecker(intervalMs = 60_000) {
  let current: string | null = null;

  async function forceHardReload() {
    try {
      // unregister service workers
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(
          regs.map(async (r) => {
            try {
              await r.update();
              await r.unregister();
            } catch {}
          }),
        );
      }

      // clear Cache Storage
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (e) {}

    const sep = window.location.search ? '&' : '?';
    window.location.replace(
      window.location.pathname + window.location.search + sep + '_=' + Date.now(),
    );
  }

  async function fetchMeta() {
    try {
      const res = await fetch('/meta.json', { cache: 'no-store' });
      if (!res.ok) return;
      const j = await res.json();
      const remoteId = j?.buildId ?? null;
      if (!current) current = remoteId;
      else if (remoteId && remoteId !== current) {
        // новая версия — перезагрузить страницу
        console.log('New build detected', { current, remoteId });
        await forceHardReload();
      }
    } catch (e) {
      console.warn('versionChecker fetch failed', e);
    }
  }

  fetchMeta();
  const id = window.setInterval(fetchMeta, intervalMs);
  return () => window.clearInterval(id);
}
